<template>
  <main class="dn-margin-1">
    <InfoCard
      v-for="card in cards"
      :key="card.type"
      :title="card.title"
      v-show="card.invisible"
      @click="oPage(card.type)"
    />
  </main>
</template>

<script>
import InfoCard from './InfoCard.vue';
import { getProductById } from '@/config/products'

export default {
  name: 'xxxz',
  components: { InfoCard },
  data () {
    return {
      toPage: '',
      qd: ''
    }
  },
  created () {
    this.qd = this.$route.query.qd || this.$route.query.q || '';
    this.toPage = this.$route.query.toPage || '';
  },
  computed: {
    product() {
      return getProductById(this.toPage) || {}
    },
    appshow() {
      return this.product.appshow !== false
    },
    passshow() {
      return this.product.passshow !== false
    },
    cards() {
      return [
        { type: 'azzn', title: '快速安装指南', invisible: true},
        { type: 'appd', title: '官方APP下载', invisible: this.appshow },
        { type: 'useo', title: '产品使用说明', invisible: true},
        { type: 'passis', title: '添加品牌私人助理', invisible: this.passshow },
      ];
    }
  },
  methods: {
    oPage(type) {
      const actionMap = {
        azzn: () => {
          this.$router.push(`/model1?toPage=${this.toPage}&qd=${this.qd}`)
        },
        appd: () => {
          window.location.href = 'https://dailyneatyoss.ezhousetech.net/dnapk/daily-neaty.apk'
        },
        useo: () => {
          if (this.product && this.product.manual) {
            window.location.href = this.product.manual
          } else {
            console.warn('找不到对应的产品手册:', this.toPage)
          }
        },
        passis: () => {
          this.$router.push(`/AssiPage?type=${this.toPage}`)
        }
      }

      const action = actionMap[type]
      if (action) action()
      else console.warn('未知操作类型:', type)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xxxz.vue